import { render, staticRenderFns } from "./SupplierReturnOrders.vue?vue&type=template&id=70460207&"
import script from "./SupplierReturnOrders.vue?vue&type=script&lang=js&"
export * from "./SupplierReturnOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports